import React from 'react';
import { SortOrder as ReactTableSortOrder } from 'react-bootstrap-table-next';

import Table from '../../../../../../../../shared/design-system/components/organisms/table';
import { PaginationShowHide } from '../../../../../../../../shared/design-system/components/organisms/table/types';
import { getDoNotCallListColumns } from './utils/get-do-not-call-list-columns';

import { DoNotCallListsSortBy } from '../../../../../../enums/do-not-call-list';
import {
  DoNotCallList,
  DoNotCallListsFilter,
  PaginationOptions,
} from '../../../../../../types/do-not-call-list';

import history from '../../../../../../../../shared/history';
import { SortOrder } from '../../../../../../../../shared/enums/order';
import hasPermission from '../../../../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../../../../shared/utils/access-control/enums/permissions';

const SORT_KEY_TO_DATA_FIELD: Record<DoNotCallListsSortBy, string> = {
  [DoNotCallListsSortBy.Total]: 'totalCount',
  [DoNotCallListsSortBy.ClientAssociated]: 'client',
  [DoNotCallListsSortBy.UpdatedAt]: 'updatedAt',
};

type IProps = {
  doNotCallLists: DoNotCallList[];
  doNotCallListsPaginationOptions: PaginationOptions;
  filters: DoNotCallListsFilter;
  onFiltersChange: (payload: Partial<DoNotCallListsFilter>) => void;
  onAction: (key: string, doNotCallList: DoNotCallList) => void;
  isLoading: boolean;
};

const DoNotCallListTable: React.FC<IProps> = ({
  doNotCallLists,
  doNotCallListsPaginationOptions,
  filters,
  onFiltersChange,
  onAction,
  isLoading,
}) => {
  const onPaginationOptionsChange = ({ page, limit }) => {
    if (filters.page === page && filters.limit === limit) {
      return;
    }
    onFiltersChange({ page, limit });
  };

  const onSort = (key: DoNotCallListsSortBy, order: ReactTableSortOrder) => {
    const newFilters = {
      sortByKey: key,
      order: order === 'asc' ? SortOrder.ASC : SortOrder.DESC,
    };

    if (
      newFilters.sortByKey !== filters.sortByKey ||
      newFilters.order !== filters.order
    ) {
      onFiltersChange(newFilters);
    }
  };

  return (
    <div className="do-not-contact-list-table-wrapper">
      <Table
        columns={getDoNotCallListColumns({
          onSort,
          onAction,
          isCellClickable: hasPermission(Permissions.DNC_LIST_READ),
        })}
        data={doNotCallLists}
        sort={{
          dataField:
            SORT_KEY_TO_DATA_FIELD[filters.sortByKey] ?? filters.sortByKey,
          order: filters.order === SortOrder.ASC ? 'asc' : 'desc',
        }}
        paginationOptions={{
          options: {
            limit: doNotCallListsPaginationOptions?.itemsPerPage,
            page: doNotCallListsPaginationOptions?.currentPage,
            totalElements: doNotCallListsPaginationOptions?.totalItems,
          },
        }}
        tableWrapperClasses="do-not-contact-list-table"
        {...(hasPermission(Permissions.DNC_LIST_READ) && {
          onRowClickHandler: (row: DoNotCallList) => {
            history.push({
              pathname: `/settings/call-dnc-list/${row.id}`,
              state: { row },
            });
          },
        })}
        isLoading={isLoading}
        pagination={PaginationShowHide.SHOW}
        isNewPagination={true}
        onPaginationOptionsChange={onPaginationOptionsChange}
      />
    </div>
  );
};

export default DoNotCallListTable;
